import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-turnDescend",
  "use": "icon-turnDescend-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol viewBox=\"0 0 11 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-turnDescend\">\n<path d=\"M3 4.5L7 9L11 4.5H3Z\" fill=\"#EB3131\" />\n<path d=\"M7 5V3C7 1.89543 6.10457 1 5 1H0\" stroke=\"#EB3131\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol